module.exports = {"230603011":"兴化街道","230603012":"卧里屯街道","230603013":"东光街道","230603014":"龙凤街道","230603015":"三永街道","230603016":"龙政街道","230603017":"湿地街道","230603100":"龙凤镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230603.json
// module id = 821
// module chunks = 0